<template>
    <div class="xi">
        <hd-com></hd-com>
        <searchhdCom></searchhdCom>
           <div class="content-wrap">
            <div class="center-box">
                <div class="content clearfix" style="position: relative;">
                     <div class="center-center flex-start flex-wrap">
                        <div class="shopGoodBox">
                            <div class="adressGoodBoxTop" style="margin-top:0">
                                <span>选择收货地址</span> 
                                <div class="shopGoodBoxTop">
                                    <div v-if="listData.length > 0">
                                         <!-- <el-button size="mini" type="primary" round style='margin-left:30px'> 修改</el-button> -->
                                        <div v-if="listDataDefaut.isDefault" style="margin-bottom:18px"> <i class="el-icon-location-outline"></i> <span  style='margin-left:8px'>默认地址</span> </div>
                                        <div><span style="color:#999999">收货人：</span>{{listDataDefaut.addressee}}  <span style='margin-left:30px;color:#999999'>联系方式：</span>{{listDataDefaut.showphone}} </div>
                                        <div style="margin-top:14px"><span style="color:#999999">收货地址：</span>{{listDataDefaut.fullAddress}}</div> 
                                    </div>
                                    <div v-else>
                                        暂无收货地址
                                    </div>
                                    <div>
                                        <!-- <div>地址切换</div> -->
                                        <!-- <div style="margin-bottom:10px">
                                            <el-button  v-if="listData.length > 0" size="mini" type="primary" round @click="goChooseClick">选择地址</el-button>
                                        </div>
                                        <div>
                                            <el-button  size="mini" type="primary" round @click="gonewClick">新建地址</el-button>
                                        </div>  -->
                                        <el-button  v-if="listData.length > 0" size="mini" type="primary" round @click="goChooseClick">选择地址</el-button>
                                        <el-button  size="mini" type="primary" round @click="gonewClick">新建地址</el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="adressGoodBoxTop">
                                <span>确认订单信息</span>
                                <div class="shopGoodBoxCenter">
                                   <div class="shopTitle">
                                    <div style="width:40%">商品信息</div>
                                    <div style="width:20%;text-align: center;">单价</div>
                                    <div style="width:20%;text-align: center;">数量</div>
                                    <div style="width:20%;text-align: center;">小计</div>
                                   </div>
                                </div>
                                <div class="adressGoodDetail"  v-for="(item,index) in shopGoodList" :key="index">
                                    <div class="adressGoodDetailTitle">
                                       包裹{{ index + 1 }}： <span> {{item.merchant}}</span>
                                    </div>
                                    <div class="adressGoodDetailCon" v-for="(item1,index1) in item.dataInfo" :key="index1">
                                       <div style="width:40%;display: flex;">
                                            <div class="adressGoodDetailImg">
                                                <el-image v-if="item1.coverImageUrls"
                                                style="width: 100%; height: 100%"
                                                :src="Services.ossUpload + item1.coverImageUrls"
                                                :fit="fit">
                                            </el-image>
                                            </div>
                                            <div>
                                                <div style="font-size: 16px;color: #333333;">{{item1.goodName}}</div>
                                                <div style="color:#999999;">{{item1.name}}<i class="el-icon-arrow-down" style="margin-left:5px"></i></div>
                                            </div>
                                       </div>
                                       <div  style="width:20%;text-align: center;">￥{{item1.ordinaryPrice}}</div>
                                       <div  style="width:20%;text-align: center;">{{item1.num}}</div>
                                       <div  style="width:20%;text-align: center;color:#E30D0D">￥{{ (item1.ordinaryPrice *  item1.num).toFixed(2) }}</div>
                                    </div>
                                    <!-- 留言 -->
                                    <div class="adressGoodDetailBto">
                                        <div style="display: flex;">
                                            <span>给卖家留言：</span>
                                            <el-input
                                                type="textarea"
                                                :rows="2"
                                                placeholder="选填，请先和卖家商量一致，付款后卖家可见"
                                                v-model="item.remakeValue"
                                                style="width:400px"
                                                >
                                            </el-input>
                                        </div>
                                        <div>
                                            <div>
                                                <span>快递运费：</span>
                                                <span v-if="item.totalFreight" style="color:#E30D0D">￥{{item.totalFreight}}</span>
                                                <span v-if="item.totalFreight == 0">免运费</span>
                                            </div>
                                            <!-- <div>
                                                <span>店铺合计：</span>
                                                <span>￥178.00</span>
                                            </div> -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="adressGoodBoxpayBox"> 
                                <div></div>
                                <div class="adressGoodBoxpay">
                                <div>
                                    <span>实付款：</span>
                                    <span style="font-size: 28px;color:#E30D0D"><span style="color:#999999">￥</span>{{payNowMoneyPrice}}</span>
                                </div>
                                <div>
                                    {{listDataDefaut.fullAddress}}
                                </div>
                                <div style="margin-top:5px">
                                    <span>{{listDataDefaut.addressee}}</span>
                                    <span style="margin-left:5px">{{listDataDefaut.showphone}}</span>
                                </div>
                                </div>
                            </div>
                            <div class="adressGoodBoxpayBox" >
                                 <div></div>
                                 <div>
                                    <!-- <span><i class="el-icon-back"></i>返回购物车</span> -->
                                    <el-button type="primary" @click="goCreatedPay">立即付款</el-button>
                                 </div>
                                
                            </div>
                        </div>
                     </div>
                </div>
            </div>
            <!--地址 -->
        <el-dialog
            title="地址管理"
            :visible.sync="dialogVisibleAdress"
            width="30%"
            >
                <div :class="indexAdress == index ? 'AdressChecked' : 'AdressCheck'" v-for="(item,index) in listData" :key="index" @click="goChoose(item,index)"> 
                    <div>
                        <span>收货人：</span><span>{{item.addressee}}</span> <span v-if="item.isDefault" style="color: #00AFB5;margin-left:10px">默认地址</span>
                    </div>   
                    <div>
                        <span>联系方式：</span><span>{{item.showphone}}</span>
                    </div>   
                    <div>
                        <span>收货地址：</span><span>{{item.fullAddress}}</span>
                    </div>   
                </div>
                 <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="goSureAdress">确定</el-button>
                    <el-button type="primary" @click="goEditAdress">修改</el-button>
                    <el-button  @click="cancleSureAdress">取消</el-button>
                </span>
            </el-dialog>
        <el-dialog
            title="地址管理"
            :visible.sync="dialogVisible"
            width="30%"
            >
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="地区" prop="regionId">
                    <el-cascader :placeholder="ruleForm.regionName ? ruleForm.regionName : '请选择所在区域'"
                            v-model="ruleForm.regionId"
                            :options="RegionData"
                            size="medium"
                            :props="{  emitPath: false, multiple: false, checkStrictly: true,lazy: true,lazyLoad:LasyLoadRegion, value:'id',label:'regionName',children:'childrens' }"
                            style="margin-right: 10px;width: 100%;"
                            @change="gochange"
                            ref="refSubCat"
                            >
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细住址" prop="address">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
                <el-form-item label="收货人" prop="addressee">
                    <el-input type="addressee" v-model="ruleForm.addressee"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input type="phone" v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="是否设为默认" prop="isDefault">
                    <el-switch v-model="ruleForm.isDefault"></el-switch>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>


           </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>


import hdCom from '../../components/intshopheader'
import searchhdCom from '../../components/insearchHeader'

import ftCom from '../../components/footer'
// import rtBar from "../../components/right";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall"
export default {
    name: "healthKnow",
    components: {
        hdCom,
        searchhdCom,
        ftCom,
        // rtBar
    },
    data() {
        var shopping = new shoppingMall(this.TokenClient, this.Services.shoppingMall)
        var region = new shoppingMall(this.TokenClient, this.Services.Authorization);
        return {
            shoppingDomain: shopping,
            Region: region,
            DetailData:{},
            numTotal:1,
            stockNum:0,
            indexCom:0,
            commodity:{},
            userAddressId:0,
            listDataDefaut:{},
            shopGoodListAdress:[],
            shopGoodList:[],
            payNowMoneyPrice:0,
            listData:[],
            dialogVisible:false,
            dialogVisibleAdress:false,
            ruleForm:{
                address: '',
                addressee: '',
                regionId: null,
                regionName:'',
                region:'',
                phone: '',
                fullAddress: '',
                isDefault: false,
                regionCode:''
            },
            RegionData:[],
            rules:{
                addressee:[
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                phone:[
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { pattern:/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur"}
                ],
            },
            indexAdress:-1
        }
    },
    methods: {
        submitForm(formName){
            var _this = this
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.ruleForm.fullAddress =  this.ruleForm.regionName + this.ruleForm.address
               let  params = _this.ruleForm
                if(_this.ruleForm.id) {
                    _this.shoppingDomain.putReceivingAddress(params,function (data) {
                        _this.ruleForm={
                            address: '',
                            addressee: '',
                            regionId: null,
                            regionName:'',
                            region:'',
                            phone: '',
                            fullAddress: '',
                            isDefault: false,
                            regionCode:''
                        },
                        _this.dialogVisible = false
                        _this.indexAdress = -1
                        _this.getList()
                        
                    },
                        function (err) {
                            _this.MessageList = []
                            console.log(err);
                        }
                    )
                } else {
                    _this.shoppingDomain.addReceivingAddress(params,function (data) {
                        _this.ruleForm={
                            address: '',
                            addressee: '',
                            regionId: null,
                            regionName:'',
                            region:'',
                            phone: '',
                            fullAddress: '',
                            isDefault: false,
                            regionCode:''
                        },
                        _this.indexAdress = -1
                        _this.dialogVisible = false
                        _this.getList()
                        
                    },
                        function (err) {
                            _this.MessageList = []
                            console.log(err);
                        }
                    )
                }
                }
           
            })
        },
        goChoose(e,index){
            this.ruleForm = e
            this.indexAdress = index
        },
        goEditAdress(){
            if (this.indexAdress == -1) {
                this.$message.error('请选择收货地址');
                return
            }
            this.dialogVisible = true
        },
        goSureAdress(){
            if (this.indexAdress == -1) {
                this.$message.error('请选择收货地址');
                return
            }
            this.listDataDefaut =  this.ruleForm
            this.userAddressId =  this.ruleForm.id
            this.dialogVisibleAdress = false
        },
        cancleSureAdress(){
            this.dialogVisibleAdress = false
            this.indexAdress = -1
        },
        goChooseClick(){
            this.indexAdress = -1
            this.dialogVisibleAdress = true
        },
        gochange(){
            this.ruleForm.regionName = this.$refs["refSubCat"].getCheckedNodes()[0].data.fullName
            this.ruleForm.regionCode = this.$refs["refSubCat"].getCheckedNodes()[0].data.regionCode
        },
        InitialRegion() {
            var _this = this;
            _this.Region.Regions(null,
                function (data) { _this.RegionData = data.data; },
                function (err) { console.log(err); });
        },
        LasyLoadRegion(node, resolve) {
                var _this = this;
                _this.Region.Regions(node.value,
                    function (data) {
                        for (var dataIndex = 0; dataIndex < data.data.length; dataIndex++) {
                            data.data[dataIndex].leaf = data.data[dataIndex].regionLevel >= 3;
                        }
                        resolve(data.data);
                    },
                    function (err) {
                        resolve([]);
                    });
        },
        gonewClick(){
            this.ruleForm={
                address: '',
                addressee: '',
                regionId: null,
                regionName:'',
                region:'',
                phone: '',
                fullAddress: '',
                isDefault: false,
                regionCode:''
            },
            this.indexAdress = -1
            this.dialogVisible = true
            this.InitialRegion()
        },
        // 计算运费
        getCalculateOrderFreight(){
            var _this = this
            _this.commodity.userAddressId = _this.userAddressId
            let param = _this.commodity
            console.log(param)
            _this.shoppingDomain.getCalculateOrderFreight(param,function (data) {
                for (let i=0;  i<data.data.length; i++) {
                    for (let j=0; j<_this.shopGoodList.length; j++) {
                        if (data.data[i].merchantShopId == _this.shopGoodList[j].merchantId) {
                                // this.shopGoodList[j].totalFreight = res.data.data[i].freight
                                _this.$set(_this.shopGoodList[j],'totalFreight', data.data[i].freight)
                        }
                    }
        
                }
                let sum = 0
                _this.shopGoodListAdress.forEach(item => {
                    sum += item.ordinaryPrice * item.num
                })
                _this.shopGoodList.forEach(item => {
                    sum += item.totalFreight
                })
                _this.payNowMoneyPrice = sum.toFixed(2)
                console.log(_this.shopGoodList)
            },
            function (error) {

            })
        },
        getList(){
            var _this = this
            _this.shoppingDomain.getReceivingAddress(function (data) {
                for (let i=0; i<data.data.length; i++) {
                    data.data[i].showphone = data.data[i].phone.substr(0,3) + "****" + data.data[i].phone.substr(7)
                    if (data.data[i].isDefault) {
                        _this.listDataDefaut = data.data[i]
                        _this.userAddressId = data.data[i].id
                    } else {
                        _this.listDataDefaut = data.data[0]
                        _this.userAddressId = data.data[0].id
                    }
                }
                _this.listData = data.data
                _this.getCalculateOrderFreight()
            },
            function (error) {

            })
        },
        // 处理数据
        checkSameData(resData){
            let tempArr = [];
            let Data = [];
            for (let i = 0; i < resData.length; i++) {
                if (tempArr.indexOf(resData[i].shopId) == -1) {
                    Data.push({
                    merchant: resData[i].shopName,
                    dataInfo: [resData[i]],
                    merchantId:  resData[i].shopId
                    });
                    tempArr.push(resData[i].shopId);
                } else {
                    for (let j = 0; j < Data.length; j++) {
                    if (Data[j].merchantId == resData[i].shopId) {
                        Data[j].dataInfo.push(resData[i]);
                        break;
                    }
                    }
                }
                }
                return Data
        },
        //详情获取
        initDetail() {
            // 直接下单
            var _this = this;
            _this.shopGoodListAdress = JSON.parse(_this.$route.query.commodity)
            _this.shopGoodList = _this.checkSameData(JSON.parse(_this.$route.query.commodity))
            _this.commodity.commoditySpecificationsId = JSON.parse(_this.$route.query.commodity)[0].commoditySpecificationsId
            _this.commodity.num = JSON.parse(_this.$route.query.commodity)[0].num
            _this.commodity.purchaseType = 0
            _this.commodity.userAddressId = _this.userAddressId
        },
        goCreatedPay(){
            var _this = this
            	// 统一下单不再区分下单
				let orderRemarks = []
				_this.shopGoodList.map((res)=>{
					if (res.remakeValue) {
						orderRemarks.push({
							shopId:res.merchantId,
							remark:res.remakeValue
						})
					}
				})
				_this.commodity.userAddressId = _this.userAddressId
				_this.commodity.orderRemarks = orderRemarks
				let param = _this.commodity
                _this.shoppingDomain.SingerConfirmOrder(param,function (data) {
                    console.log(data)
                    if (data.code == 200) {
						_this.comfirmData = data.data
                            _this.$router.push({
                                path: './shopPay',
                                query: {
                                    order: _this.comfirmData.leadOrderNumber,
                                    totalMoney:_this.comfirmData.payMoney
                                }
                            })
					} else {
                        _this.$message({
                            message: data.msg,
                            type: 'warning'
                        });
					}
                    
                },
                function (err) {
                      console.log(data)
                    _this.$message({
                        message: err.msg,
                        type: 'warning'
                    });
                }
            )
        },
    },
    mounted() {
        this.initDetail();
        this.getList()
    },
    destroyed() {
        //销毁监听
    },
}
</script>
<style lang="scss" scoped>
.shopTab {
    border-bottom: 1px solid #E6E6E6;
}
.shopTabBox {
    display: flex;
    align-items: center;
}
.shopTabno {
    font-size: 15px;
    // color: #FFFFFF;
    font-weight: bold;
    padding: 10px 50px;
    cursor: pointer;
}
.shopTabChecked {
    font-size: 15px;
    padding: 10px 50px;
     cursor: pointer;
}
.tagcomCheck {
    padding: 5px 15px;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    font-size: 14px;
    color: #00AFB5;
    margin-left: 10px;
    cursor: pointer;
}
.tagcom {
    padding: 5px 15px;
    background: #F0F0F0;
    border-radius: 2px;
    font-size: 14px;
    margin-left: 10px;
    color: #333333;
    cursor: pointer;
}

.banner {
    height: 116px;
    background: url("../../assets/img/jbk_banner.png")center no-repeat;
}
.shopGoodBox {
    width: 100%;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 30px;
}
.flex-l {
    display: flex;
    align-items: center;
}
.shopGoodBoxTop {
  border-radius: 8px;
  border: 1px solid #E6E6E6;
  padding: 35px 30px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
   font-size: 14px;
    color: #333333;
}
.shopGoodBoxCenter {
    margin-top: 15px;
}
// .shopGoodBoxCenter {
//     background: #F2F2F2;
//     border-radius: 8px;
// }
.adressGoodBoxTop {
    margin-top: 30px;
}
.AdressChecked {
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    padding: 20px 30px;
    margin-bottom: 20px;
}
.AdressCheck {
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #CCCCCC;
    padding: 20px 30px;
    margin-bottom: 20px;
}
.shopGoodBoxTopAdress {
    font-size: 14px;
    color: #333333;
}
.shopTitle {
    background: #F2F2F2;
    border-radius: 8px;
    padding: 15px 45px;
    display: flex;
    align-items: center;
}
.adressGoodBoxTop span {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
}
.adressGoodDetail {
    border-radius: 8px;
    border: 1px solid #E6E6E6;
    margin-top: 10px;
   
}
.adressGoodDetailTitle {
    background: #F7F4EC;
    border-radius: 8px 8px 0px 0px;
     padding: 19px;
}
.adressGoodDetailCon {
    display: flex;
    align-items: center;
    padding: 20px;
    border: 1px solid #E6E6E6;
    color: #333333;
}
.adressGoodDetailImg {
    background: #E8E9EA;
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    width: 60px;
    height: 60px;
    margin-right: 10px;
}
.adressGoodBoxpayBox {
      display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
}
.adressGoodBoxpay {
    width: 560px;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    padding: 30px 20px;
    text-align: right;
}
.adressGoodDetailBto {
    background: #F7F7F7;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.shopGoodBoxRight {
    margin-left: 60px;
}
.shopGoodBoxName {
    font-weight: bold;
    font-size: 20px;
    color: #1A1A1A;
}
.shopGoodPrice {
    font-size: 24px;
    color: #E1251B;
    margin-bottom: 30px;
}
.shopGoodBot {
    margin-top: 30px;
}
.shopGoodBoxSold {
    font-size: 16px;
    color: #CCCCCC;
}
.banner-text {
    width: 1200px;
    margin: 0 auto;

    h3 {
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    p {
        font-size: 18px;
        color: #ffffff;

        a {
            color: #ffffff;
            font-size: 14px;
            margin: 0 5px;
        }
    }
}

.content-wrap {
    background: #F5F6F6;
}


.content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;

}

.menu-box {
    width: 100%;
    background: #fff;
    height: auto;

    .box {
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .menu-title {
        width: 90px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-content {
        width: calc(100% - 95px);
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-item {
        width: auto;
        margin: 0 5px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 40px;
        padding: 0 10px;
    }

    .menu-item:hover {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
        cursor: pointer;
    }

    .menuActive {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
    }
}



.healthKnow .el-radio {
    margin-right: 30px;
}

#page ::v-deep .el-pagination {
    text-align: center;
    margin: 30px auto;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    background-color: #fff;
}

#page ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #01C2AC;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    border-radius: 2px;
}
</style>
